import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from "@angular/forms";
import { HttpClient, HttpEvent, HttpEventType } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';
import { ChartType } from 'chart.js';
import { MultiDataSet, Label, Color } from 'ng2-charts';

import * as moment from 'moment'
import 'moment-timezone';
import { NgxSpinnerService } from "ngx-spinner";

import { LoginService } from '../services/login.service';
import { DashboardService } from '../services/dashboard.service';

@Component({
    selector: 'app-analysis',
    templateUrl: './analysis.component.html',
    styleUrls: ['./analysis.component.css']
})
export class AnalysisComponent implements OnInit {

    public project_id: any = {};
    public session_data: any = {};
    public err: any = {};
    public result: any = {};
    public sentiment = 'all';
    public country = '';
    public checked_sm: any = { all: true, twitter: false, facebook: false, instagram: false, web: false, youtube: false, reviews: false, others: false, linkedin: false, reddit: false };
    public pie_percentage: any = { twitter: 0, facebook: 0, instagram: 0, web: 0, youtube: 0, reviews: 0, others: 0, linkedin: 0, reddit: 0 };
    public mmapLoading = false;
    public popularLoading = false;
    public popular_mentions = [];
    public profile_mentions = [];
    public countries: any = {};
    public summary: any = {};
    public total_per_sm: any = {};
    public text_search = '';
    public language = 'any';
    public show_tag_form: boolean = false;
    public total: number = 0;
    public total_profiles: number = 0;
    p: number = 0;
    public blocked_items: any = {};
    //  total: number = 100;
    page_length: number = 10;

    profile_p: number = 0;
    profile_page_length: number = 10;

    sentimant_filter_value = 0;
    sentimant_filter_options = {
        showTicksValues: true,
        hideLimitLabels: true,
        hidePointerLabels: true,
        stepsArray: [
            { value: -1, legend: "Negative" },
            { value: 0, legend: "All" },
            { value: 1, legend: "Positive" }
        ]
    };

    public selected: any = {};
    public selected_dates: any = {};
    alwaysShowCalendars: boolean;
    showRangeLabelOnInput: boolean;
    keepCalendarOpeningWithRange: boolean;
    ranges: any = {
        Today: [moment(), moment()],
        Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        'Last 7 Days': [moment().subtract(6, 'days'), moment()],
        'Last 30 Days': [moment().subtract(29, 'days'), moment()],
        'This Month': [moment().startOf('month'), moment().endOf('month')],
        'Last Month': [
            moment()
                .subtract(1, 'month')
                .startOf('month'),
            moment()
                .subtract(1, 'month')
                .endOf('month')
        ],
        'Last 3 Month': [
            moment()
                .subtract(3, 'month')
                .startOf('month'),
            moment()
                .subtract(1, 'month')
                .endOf('month')
        ]
    };

    public doughnutChartLabels: Label[] = [];
    public doughnutChartColors: Array<any> = [];
    public doughnutChartOptions: any = {
        tooltips: {
            callbacks: {
                label: function(tooltipItem, data) {
                    var dataset = data.datasets[tooltipItem.datasetIndex];
                    var label = data.labels[tooltipItem.index];
                    var total = dataset.data.reduce(function(previousValue, currentValue, currentIndex, array) {
                        return previousValue + currentValue;
                    });
                    var currentValue = dataset.data[tooltipItem.index];
                    var percentage = Math.floor(((currentValue / total) * 100) + 0.5);
                    return label + ': ' + percentage + "%";
                }
            }
        },
        legend: {
            display: true,
            position: 'right',
            labels: {
                fontSize: 10,
                generateLabels: function(chart) {
                    var data = chart.data;
                    if (data.labels.length && data.datasets.length) {
                        return data.labels.map(function(label, i) {
                            var ds = data.datasets[0];
                            var color = ds.backgroundColor[i];
                            var total = ds.data.reduce((a, b) => parseInt(a) + parseInt(b), 0);
                            var percentage = Math.floor(((ds.data[i] / total) * 100) + 0.5);
                            return { text: percentage + "% " + label, fillStyle: color };
                        });
                    }
                }
            }
        }
    };
    public doughnutChartData = [];
    public doughnutChartLegend = true;
    public doughnutChartType: ChartType = 'doughnut';

    header_data: any = { heading: "Mentions" };

    constructor(private router: Router, private service: DashboardService, private login: LoginService, private route: ActivatedRoute, private spinner: NgxSpinnerService) {
        this.session_data.id = login.get_session_data('ieye_session_id');
        this.service.setTitle('Analysis | 24ieye');
        this.project_id = this.route.snapshot.queryParams["id"];
        this.alwaysShowCalendars = true;
        this.keepCalendarOpeningWithRange = true;
        this.selected = { startDate: login.get_session_data('ieye_session_start_date'), endDate: login.get_session_data('ieye_session_end_date') };
        this.countries = this.get_countries();
    }

    ngOnInit(): void {
        //this.get_mentions_graph(this.selected.startDate, this.selected.endDate);
        this.get_mentions(this.selected.startDate, this.selected.endDate, 'all', 'popular', this.page_length, this.p);
        this.get_mentions(this.selected.startDate, this.selected.endDate, 'all', 'top_profiles', this.profile_page_length, this.profile_p);
        this.get_summary(this.selected.startDate, this.selected.endDate);
        this.get_mentions_per_sm(this.selected.startDate, this.selected.endDate);
    }

    public async get_countries() {
        this.result = await this.service.get_actions({}, 'countries');
        this.countries = this.result;
    }

    public tag_form() {
        this.show_tag_form = true;
    }

    public close_tag_form() {
        this.show_tag_form = false;
    }

    public reset_filter() {
        this.sentimant_filter_value = 0;
        this.text_search = '';
        this.language = 'any';
        this.country = '';
        this.checked_sm.twitter = true;
        this.checked_sm.twitter = this.checked_sm.facebook = this.checked_sm.web = this.checked_sm.instagram = this.checked_sm.youtube = this.checked_sm.reviews = this.checked_sm.others = this.checked_sm.linkedin = this.checked_sm.reddit = false;
        this.senitment_filter_event(this.sentimant_filter_value);
    }

    public filter_by_country(event) {
        this.p = 1;
        this.country = event.target.value;
        this.senitment_filter_event(this.sentimant_filter_value);
    }

    public language_filter() {
        var language = (<HTMLInputElement>document.getElementById('language_filter')).value;
        this.language = language;
        this.senitment_filter_event(this.sentimant_filter_value);
    }

    public text_filter() {
        var text = (<HTMLInputElement>document.getElementById('search_text')).value;
        this.text_search = text;
        this.senitment_filter_event(this.sentimant_filter_value);
    }

    public senitment_filter_event(val) {
        this.p = 0;
        this.profile_p = 0;
        this.sentimant_filter_value = val;
        this.get_mentions(this.selected.startDate, this.selected.endDate, 'all', 'popular', this.page_length, this.p);
        this.get_mentions(this.selected.startDate, this.selected.endDate, 'all', 'top_profiles', this.profile_page_length, this.profile_p);
        this.get_summary(this.selected.startDate, this.selected.endDate);
        this.get_mentions_per_sm(this.selected.startDate, this.selected.endDate);
    }

    public sm_checkbox_event(e) {
        if ('all' == e.target.value) {
            this.checked_sm.twitter = this.checked_sm.facebook = this.checked_sm.web = this.checked_sm.instagram = this.checked_sm.youtube = this.checked_sm.reviews = this.checked_sm.others = this.checked_sm.linkedin = this.checked_sm.reddit = false;
        }
        if ('twitter' == e.target.value)
            this.checked_sm.twitter = e.target.checked ? true : false;
        if ('facebook' == e.target.value)
            this.checked_sm.facebook = e.target.checked ? true : false;
        if ('web' == e.target.value)
            this.checked_sm.web = e.target.checked ? true : false;
        if ('instagram' == e.target.value)
            this.checked_sm.instagram = e.target.checked ? true : false;
        if ('youtube' == e.target.value)
            this.checked_sm.youtube = e.target.checked ? true : false;
        if ('reviews' == e.target.value)
            this.checked_sm.reviews = e.target.checked ? true : false;
        if ('others' == e.target.value)
            this.checked_sm.others = e.target.checked ? true : false;

        if (this.checked_sm.linkedin && this.checked_sm.reddit) {
            this.checked_sm.others = true;
        } else {
            this.checked_sm.others = false;
        }

        if (this.checked_sm.twitter || this.checked_sm.facebook || this.checked_sm.web || this.checked_sm.instagram || this.checked_sm.youtube || this.checked_sm.reviews || this.checked_sm.others || this.checked_sm.linkedin || this.checked_sm.reddit) {
            this.checked_sm.all = false;
        } else {
            this.checked_sm.all = true;
        }
        this.senitment_filter_event(this.sentimant_filter_value);
    }

    datesUpdated(range) {
        if (range.startDate != null && range.endDate != null) {
            this.service.saveDateRange(moment(range.startDate._d).format("YYYY-MM-DD"), moment(range.endDate._d).format("YYYY-MM-DD"));
            this.selected = { startDate: this.login.get_session_data('ieye_session_start_date'), endDate: this.login.get_session_data('ieye_session_end_date') };
            this.get_summary(this.selected.startDate, this.selected.endDate);
            this.get_mentions(this.selected.startDate, this.selected.endDate, 'all', 'popular', this.page_length, this.p);
            this.get_mentions(this.selected.startDate, this.selected.endDate, 'all', 'top_profiles', this.profile_page_length, this.profile_p);
            this.get_mentions_per_sm(this.selected.startDate, this.selected.endDate);
        }
    }

    public async get_summary(start, end) {
        this.summary.all = this.summary.interactions = this.summary.positive = this.summary.negative = this.summary.sm = this.summary.nsm = '<img src="assets/images/small-loader.gif">';
        var formData: any = new FormData();
        formData.append("user_id", this.session_data.id);
        formData.append("type", 'summary');
        formData.append("start_date", start);
        formData.append("end_date", end);
        formData.append("per_page", 1);
        formData.append("text_search", this.text_search);
        formData.append("sentiment", this.sentimant_filter_value);
        formData.append("project_id", this.route.snapshot.queryParams["id"]);
        formData.append("language", this.language);
        formData.append("country", this.country);

        this.result = await this.service.form_actions(formData, 'mentions');
        if (this.result.status == false) {
            if (this.result.code == 202) {
                this.err = {};
                Swal.fire('Alert!', this.result.message, 'error');
            } else {
                this.err = this.result.errors;
            }
        } else {
            this.summary.all = this.result.data.all;
            this.summary.interactions = this.result.data.interactions;
            this.summary.positive = this.result.data.positive;
            this.summary.negative = this.result.data.negative;
            this.summary.sm = this.result.data.sm;
            this.summary.nsm = this.result.data.nsm;
        }
    }

    public async get_mentions(start, end, mention_type, list_type, page_length, page_no) {
        this.spinner.show();
        this.popularLoading = true;
        var formData: any = new FormData();
        formData.append("user_id", this.session_data.id);
        formData.append("type", list_type);
        formData.append("start_date", start);
        formData.append("end_date", end);
        formData.append("per_page", page_length);
        formData.append("page_no", page_no);
        formData.append("pager", this.total);
        formData.append("sentiment", this.sentimant_filter_value);
        formData.append("text_search", this.text_search);
        formData.append("language", this.language);
        formData.append("country", this.country);
        formData.append("channels[twitter]", this.checked_sm.twitter);
        formData.append("channels[facebook]", this.checked_sm.facebook);
        formData.append("channels[instagram]", this.checked_sm.instagram);
        formData.append("channels[web]", this.checked_sm.web);
        formData.append("channels[youtube]", this.checked_sm.youtube);
        formData.append("channels[reviews]", this.checked_sm.reviews);
        formData.append("channels[others]", this.checked_sm.others);
        formData.append("channels[all]", this.checked_sm.all);
        formData.append("project_id", this.route.snapshot.queryParams["id"]);
       /* if (list_type == 'popular')
            formData.append("sort", 'engagement');
        if (list_type == 'top_profiles')
            formData.append("sort", 'followers_count');*/

        this.result = await this.service.form_actions(formData, 'mentions');
        if (this.result.status == false) {
            this.spinner.hide();
            this.popularLoading = false;
            if (this.result.code == 202) {
                this.err = {};
                Swal.fire('Alert!', this.result.message, 'error');
            } else {
                this.err = this.result.errors;
            }
        } else {
            this.spinner.hide();
            this.popularLoading = false;
            if (list_type == 'popular') {
                this.popular_mentions = this.result.data.mentions;
                this.total = this.result.count;
            }

            if (list_type == 'top_profiles') {
                this.profile_mentions = this.result.data.mentions;
                this.total_profiles = this.result.count;
                //if(this.blocked_items.length == 0){
                this.blocked_items.mentions = this.result.user.blocked_mentions;
                this.blocked_items.profiles = this.result.user.blocked_profiles;
                //}
            }
        }
    }

    public pageChanged(page) {
        window.scroll(0, 0);
        this.p = page;
        this.get_mentions(this.selected.startDate, this.selected.endDate, 'all', 'popular', this.page_length, this.p);
    }

    public profilePageChanged(page) {
        window.scroll(0, 0);
        this.profile_p = page;
        this.get_mentions(this.selected.startDate, this.selected.endDate, 'all', 'top_profiles', this.profile_page_length, this.profile_p);
    }

    public change_date_format(date, format) {
        return moment.tz(date, 'Asia/Muscat').utc().format(format);
    }

    public get_social_icon(channel) {
        switch (channel) {
            case 'web': {
                return 'assets/images/icons/share-2.svg';
                break;
            }
            case 'facebook': {
                return 'assets/images/icons/facebook.svg';
                break;
            }
            case 'instagram': {
                return 'assets/images/icons/instagram.svg';
                break;
            }
            case 'twitter': {
                return 'assets/images/icons/twitter.svg';
                break;
            }
            case 'youtube': {
                return 'assets/images/icons/youtube.svg';
                break;
            }
            case 'linkedin': {
                return 'assets/images/icons/linkedin.svg';
                break;
            }
            case 'reviews': {
                return 'assets/images/icons/message-square.svg';
                break;
            }
            default: {
                return 'assets/images/icons/rss.svg';
                break;
            }
        }
    }

    public async get_mentions_per_sm(start, end) {
        this.total_per_sm.all = this.total_per_sm.twitter = this.total_per_sm.facebook = this.total_per_sm.instagram = this.total_per_sm.web = this.total_per_sm.youtube = this.total_per_sm.reviews = this.total_per_sm.others = this.total_per_sm.linkedin = this.total_per_sm.reddit = '<img src="assets/images/small-loader.gif">';
        var formData: any = new FormData();
        formData.append("user_id", this.session_data.id);
        formData.append("type", 'count_per_sm');
        formData.append("start_date", start);
        formData.append("end_date", end);
        formData.append("per_page", 10);
        formData.append("sentiment", this.sentimant_filter_value);
        formData.append("text_search", this.text_search);
        formData.append("country", this.country);
        formData.append("project_id", this.route.snapshot.queryParams["id"]);
        formData.append("language", this.language);

        this.result = await this.service.form_actions(formData, 'mentions');
        if (this.result.status == false) {
            if (this.result.code == 202) {
                this.err = {};
                Swal.fire('Alert!', this.result.message, 'error');
            } else {
                this.err = this.result.errors;
            }
        } else {
            this.total_per_sm.all = this.result.data.all;
            this.total_per_sm.web = this.result.data.web;
            this.total_per_sm.twitter = this.result.data.twitter;
            this.total_per_sm.facebook = this.result.data.facebook;
            this.total_per_sm.instagram = this.result.data.instagram;
            this.total_per_sm.youtube = this.result.data.youtube;
            this.total_per_sm.reviews = this.result.data.reviews;
            this.total_per_sm.others = this.result.data.others;
            this.total_per_sm.linkedin = this.result.data.linkedin;
            this.total_per_sm.reddit = this.result.data.reddit;

            this.get_doughnut_chart(this.total_per_sm);
        }
    }

    public get_doughnut_chart(data) {
        var chart_data = [];
        var backgroundColor = [];
        this.doughnutChartLabels = [];
        if (data.web != 'denied') {
            this.doughnutChartLabels.push('Web');
            chart_data.push(data.web);
            backgroundColor.push('#4392B7');
        }
        if (data.twitter != 'denied') {
            this.doughnutChartLabels.push('Twitter');
            chart_data.push(data.twitter);
            backgroundColor.push('#37A9F3');
        }
        if (data.instagram != 'denied') {
            this.doughnutChartLabels.push('Instagram');
            chart_data.push(data.instagram);
            backgroundColor.push('#F7C050');
        }
        if (data.facebook != 'denied') {
            this.doughnutChartLabels.push('Facebook');
            chart_data.push(data.facebook);
            backgroundColor.push('#4867AA');
        }
        if (data.youtube != 'denied') {
            this.doughnutChartLabels.push('Youtube');
            chart_data.push(data.youtube);
            backgroundColor.push('#FF4A4A');
        }
        if (data.reviews != 'denied') {
            this.doughnutChartLabels.push('Reviews');
            chart_data.push(data.reviews);
            backgroundColor.push('#038c99');
        }
        if (data.others != 'denied') {
            this.doughnutChartLabels.push('Linkedin');
            chart_data.push(data.linkedin);
            backgroundColor.push('#0077b5');
        }
        if (data.others != 'denied') {
            this.doughnutChartLabels.push('Reddit');
            chart_data.push(data.reddit);
            backgroundColor.push('#FF4500');
        }
        this.doughnutChartColors = [{ backgroundColor: backgroundColor }];
        this.doughnutChartData = [chart_data];
        var total = chart_data.reduce((a, b) => a + b, 0);
        this.pie_percentage.web = Math.floor(((data.web / total) * 100) + 0.5);
        this.pie_percentage.twitter = Math.floor(((data.twitter / total) * 100) + 0.5);
        this.pie_percentage.instagram = Math.floor(((data.instagram / total) * 100) + 0.5);
        this.pie_percentage.facebook = Math.floor(((data.facebook / total) * 100) + 0.5);
        this.pie_percentage.youtube = Math.floor(((data.youtube / total) * 100) + 0.5);
        this.pie_percentage.reviews = Math.floor(((data.reviews / total) * 100) + 0.5);
//        this.pie_percentage.others = Math.floor(((data.others / total) * 100) + 0.5);
        this.pie_percentage.linkedin = Math.floor(((data.linkedin / total) * 100) + 0.5);
        this.pie_percentage.reddit = Math.floor(((data.reddit / total) * 100) + 0.5);
    }

    public can_show_mention(id, profile_id) {
        var mentions = JSON.stringify(this.blocked_items.mentions);
        var profiles = JSON.stringify(this.blocked_items.profiles);
        if (mentions)
            if (mentions.indexOf(id) !== -1 || profiles.indexOf(profile_id) !== -1) {
                return 'none';
            }
        return 'block';
    }

}
